import { render, staticRenderFns } from "./WhereToBuyNav.vue?vue&type=template&id=63c487dc"
import script from "./WhereToBuyNav.vue?vue&type=script&setup=true&lang=js"
export * from "./WhereToBuyNav.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports